module.exports = function (domain) {
  document.addEventListener('DOMContentLoaded', function () {
    let bodyH = 0

    const listener = function (event) {
      if (event && event.data === 'need_height' || !event) {
        const message = {
          type: 'resize',
          height: document.body.offsetHeight + 50
        }
        window.parent.postMessage(JSON.stringify(message), domain)
      }
    }

    const scrollTopIframe = function (event) {
      const message = {
        type: 'scrolltopiframe'
      }
      window.parent.postMessage(JSON.stringify(message), domain)
    }

    const checkForNewHeight = function () {
      const newBodyH = document.body.offsetHeight
      if (bodyH !== newBodyH) {
        bodyH = newBodyH
        listener()
      }
    }

    if (window.addEventListener) {
      window.addEventListener('message', listener, false)
    } else {
      window.attachEvent('onmessage', listener)
    }

    document.querySelectorAll('[data-scrolltop-iframe]').forEach(function (element) {
      element.addEventListener('click', scrollTopIframe)
    })

    setInterval(checkForNewHeight, 250)
  })
}



// WEBPACK FOOTER //
// ./src/app/iframe.js